<template>
	<div>
		<div class="subTop1">
		  <em>Data Index</em>
		  <span>数据指数</span>
		  <router-link to="/yuntu" class="more" @click.native="$track([['pagetype','首页-数据指数-更多-点击']])">更多</router-link>
		</div>
		<dl class="w33">
			<dd v-for="(item,index) in yuntuList" v-if="index<3">
				<router-link :to="{ name: 'yuntu', params: { column: item.id+'_'+item.name }}" @click.native="$track([['pagetype','首页-数据指数-'+item.name+'-点击']])">
					<homeyuntuitem v-bind:colid="item.id" v-bind:colname="item.name"></homeyuntuitem>
				</router-link>
			</dd>
		  <!-- <dd><router-link to="/yuntu"><img src="images/data1.png"/></router-link></dd>
		  <dd><router-link to="/yuntu"><img src="images/data2.png"/></router-link></dd>
		  <dd><router-link to="/yuntu"><img src="images/data3.png"/></router-link></dd> -->
		</dl>
	</div>
</template>

<script>
	import homeyuntuitem from '@/components/home-yuntu-item.vue'
	export default {
		data() {
			return {
				isloading:true,
				yuntuList:[
					{
						id:'0546b8ad0b1745b1be0caebcde307ea5',
						name:'2022年中国自动驾驶独角兽估值排名',
						type:0,
					},
					{
						id:'d97f9a3cc29a48fdbc279823028f88f1',
						name:'2022年中国自动驾驶准独角兽估值排名',
						type:0,
					},
					{
						id:'bb91af162ca848bd9862b6f8887795ae',
						name:'2022年-2023年中国数字贸易企业排名',
						type:0,
					},
				],
			}
		},
		created:function(){
			// this.yuntufnc();
		},
		components:{
			homeyuntuitem
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
		}
	}
</script>

<style>
</style>
